import { LinkedObjectToFile } from './LinkedObjectToFile';

export class LinkedObjectsToFileWithId {
    yukiId: string;
    linkedObjects: LinkedObjectToFile[];
}
